<template>
    <v-card>
        <v-card-title style="position:fixed; z-index:9999; background:white; width:96.5%; border-bottom:1px solid rgba(0,0,0,0.2);">
        <div class="d-flex">
            <div v-if="$permissions.value.includes('edit_facture_number')">
                <v-menu
                v-model="EditNumberDialog"
                :close-on-content-click="false"
                :nudge-width="380"
                offset-x
                >
                    <template v-slot:activator="{ on, attrs }">
                        <span>Facture N°{{factureContent.num_facture}}</span>
                        <v-btn
                        small
                        fab
                        icon
                        v-bind="attrs"
                        v-on="on"
                        >
                            <v-icon
                                small
                                class="mr-0"
                            >
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-card class="px-4 py-2">
                        <v-text-field
                            v-model="numFactureToEdit"
                            :error="factureNumberError"
                            :error-messages="factureNumberErrorMessages"
                            :rules="[v => v.length >= 6 || 'Veuillez ajouter au moins 6 caractères']"
                            label="Nouveau N°Facture"
                        ></v-text-field>
                        <v-row>
                            <v-col cols="6">
                                <v-btn block color="blue darken-1" @click="close" text>Annuler</v-btn>
                            </v-col>
                            <v-col cols="6">
                                <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="updateNumber" block>Editer</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-menu>
            </div>
            <template v-else>
                <span>Facture N°{{factureContent.num_facture}}</span>
            </template>
        </div>
        <v-spacer></v-spacer>
        <div class="text-left">
            <small>Libellé</small><br/>
            {{factureContent.libelle}}
        </div>
        <v-spacer></v-spacer>
        <div class="text-left">
            <small>Avis Relatif</small><br/>
            <span v-if="factureContent.avis_id > 0">Avis N°{{avisContentData.num_avis}}</span>
            <span v-else>-</span>
        </div>
        <v-spacer></v-spacer>
        <div class="text-left">
            <small>Date Création</small><br/>
            {{factureContent.date | formatDate}}
        </div>
        </v-card-title>
        <v-row style="position:relative; width:100%; height:100%; top:100px;">
            <v-col cols="12" md="9" style="border-right:1px solid rgba(0,0,0,0.2); height:500px; overflow-y:scroll;">
                <v-card-title  style="font-size: 36px;"><span><b>Informations Générales</b></span></v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-list two-line>
                        <v-row v-if="factureContent.avis_id > 0"> 
                            <v-col cols="12" sm="6" md="3" >
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Numéro Dossier</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.num_dossier}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Type Dossier</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.type}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Classe Dossier</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.classe}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <template v-if="avisContentData.dossier.classe == 'Groupage' || avisContentData.dossier.classe == 'Complet'">
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Escale</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.escale}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Voyage</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.voyage}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Consignataire</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.consig}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Armateur</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.armateur}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Navire</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.navire}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Date d'embarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.from_date | formatDate}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Port d'embarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.port_from}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Date de débarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.to_date | formatDate}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Port de débarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.dossier.port_to}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>B/L</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.bl}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            
                                <template v-if="avisContentData.dossier.classe === 'Groupage'">
                                    <v-col cols="12" sm="6" md="3">
                                        <v-list-item class="text-left">
                                            <v-list-item-content>
                                                <v-list-item-subtitle>N° Conteneur</v-list-item-subtitle>
                                                <v-list-item-title>{{avisContentData.dossier.conteneur_num}}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-list-item class="text-left">
                                            <v-list-item-content>
                                                <v-list-item-subtitle>Type Conteneur</v-list-item-subtitle>
                                                <v-list-item-title>{{avisContentData.dossier.conteneur_type}}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-list-item class="text-left">
                                            <v-list-item-content>
                                                <v-list-item-subtitle>N° Escale Magasin</v-list-item-subtitle>
                                                <v-list-item-title>{{avisContentData.dossier.num_escale_magasin}}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-list-item class="text-left">
                                            <v-list-item-content>
                                                <v-list-item-subtitle>Date Dépotage</v-list-item-subtitle>
                                                <v-list-item-title>{{avisContentData.dossier.date_depotage | formatDate}}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </template>
                            </template>
                            <template v-else>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Compagnie Aérienne</v-list-item-subtitle>
                                            <v-list-item-title>{{avisContentData.dossier.compagnie_aerienne}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>N°LTA</v-list-item-subtitle>
                                            <v-list-item-title>{{avisContentData.dossier.num_lta}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>N°Vol</v-list-item-subtitle>
                                            <v-list-item-title>{{avisContentData.dossier.num_vol}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Date de Départ</v-list-item-subtitle>
                                            <v-list-item-title>{{avisContentData.dossier.from_date | formatDate}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Aéroport de Départ</v-list-item-subtitle>
                                            <v-list-item-title>{{avisContentData.dossier.aeroport_depart}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Date d'Arrivée</v-list-item-subtitle>
                                            <v-list-item-title>{{avisContentData.dossier.to_date | formatDate}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Aéroport d'Arrivée</v-list-item-subtitle>
                                            <v-list-item-title>{{avisContentData.dossier.aeroport_arrivee}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </template>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>P/C</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.pc}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Correspondant</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.correspondant.nom}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Client</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.client.fullname}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Agent</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.agent.nom}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Terme</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.terme}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Fournisseur</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.fournisseur}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="avisContentData.dossier.classe === 'Groupage'">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Bureau</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.bureau}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="avisContentData.dossier.classe === 'Groupage'">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Valeur</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.valeur}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="avisContentData.dossier.classe === 'Groupage'">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Code Magasin</v-list-item-subtitle>
                                        <v-list-item-title>{{avisContentData.code_magasin}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row> 
                        <v-row v-else-if="factureContent.dossier_id > 0"> 
                            <template v-if="currentDossier.classe === 'Groupage' || currentDossier.classe === 'Complet'">
                            <v-col cols="12" sm="6" md="3" >
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Numéro Dossier</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.numdossier}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Type Dossier</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.type}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Classe Dossier</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.classe}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Escale</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.escale}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Voyage</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.voyage}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Consignataire</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.consig}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Armateur</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.armateur}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Navire</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.navire}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Date d'embarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.from_date | formatDate}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Port d'embarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.port_from}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Date de débarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.to_date | formatDate}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Port de débarquement</v-list-item-subtitle>
                                        <v-list-item-title>{{currentDossier.port_to}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <template v-if="currentDossier.classe === 'Groupage'">
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>N° Conteneur</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.conteneur_num}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Type Conteneur</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.conteneur_type}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>N° Escale Magasin</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.num_escale_magasin}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Date Dépotage</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.date_depotage | formatDate}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </template>
                            </template>
                            <template v-else>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Compagnie Aérienne</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.compagnie_aerienne}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>N°LTA</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.num_lta}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>N°Vol</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.num_vol}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Date de Départ</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.from_date | formatDate}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Aéroport de Départ</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.aeroport_depart}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Date d'Arrivée</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.to_date | formatDate}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-list-item class="text-left">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Aéroport d'Arrivée</v-list-item-subtitle>
                                            <v-list-item-title>{{currentDossier.aeroport_arrivee}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </template>
                            <v-col cols="12" sm="6" md="3" v-if="currentFacture.pc">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>P/C</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.pc}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentFacture.client">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Client</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.client.fullname}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentFacture.correspondant">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Correspondant</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.correspondant.nom}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentFacture.agent">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Agent</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.agent.nom}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentFacture.terme">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Terme</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.terme}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentFacture.fournisseur">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Fournisseur</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.fournisseur}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentDossier.classe === 'Groupage' && currentFacture.bureau">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Bureau</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.bureau}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentDossier.classe === 'Groupage' && currentFacture.valeur">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Valeur</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.valeur}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="currentDossier.classe === 'Groupage' && currentFacture.code_magasin">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Code Magasin</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.code_magasin}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            
                        </v-row>
                        <v-row v-else> 
                            <v-col cols="12" sm="6" md="3" v-if="currentFacture.client">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Client</v-list-item-subtitle>
                                        <v-list-item-title>{{currentFacture.client.fullname}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-for="(dataFact, key) in currentFacture.data" v-bind:key="key">
                                <template v-if="dataFact.name !== 'dataType'">
                                <v-list-item class="text-left">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>{{dataFact.name}}</v-list-item-subtitle>
                                        <v-list-item-title>{{dataFact.value}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                </template>
                            </v-col>
                        </v-row> 
                        </v-list>
                    </v-container>
                </v-card-text>
                <v-divider style="width:98%; margin: 0 auto;"></v-divider>
                <v-card-title  style="font-size: 36px;"><b><span>{{currentFacture.dataType || 'Marchandises' }}</span></b></v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col md="12">
                                <v-simple-table class="text-left" v-if="currentFacture.dataType == 'Déclaration'" dense>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                        <th class="text-left">Déclaration N°</th>
                                        <th class="text-left">Visa</th>
                                        <th class="text-left">Quantité</th>
                                        <th class="text-left">PUHT</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="marchandises.length > 0">
                                        <tr v-for="(marchandise,index) in marchandises" v-bind:key="index">
                                            <td class="text-left">{{marchandise.rub}}</td>
                                            <td class="text-left">{{marchandise.colis}}</td>
                                            <td class="text-left">{{marchandise.description}}</td>
                                            <td class="text-left">{{marchandise.poids}}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr class="text-center">
                                            <td colspan="4">Aucune donnée disponible</td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                                <v-simple-table class="text-left" v-else dense>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                        <th class="text-left">Rub.</th>
                                        <th class="text-left">Colis.</th>
                                        <th class="text-left" v-if="currentDossier.classe !== 'Aérien' && currentDossier.classe !== 'Groupage'">Cont.N°</th>
                                        <th class="text-left" v-if="currentDossier.classe !== 'Aérien' && currentDossier.classe !== 'Groupage'">Cont.Type</th>
                                        <th class="text-left">Description</th>
                                        <th class="text-left">Poids</th>
                                        <th class="text-left" v-if="currentDossier.classe === 'Groupage'">Volume</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="marchandises.length > 0">
                                        <tr v-for="(marchandise,index) in marchandises" v-bind:key="index">
                                            <td>{{marchandise.rub}}</td>
                                            <td>{{marchandise.colis}}</td>
                                            <td v-if="currentDossier.classe !== 'Aérien' && currentDossier.classe !== 'Groupage'">{{marchandise.cont_numero}}</td>
                                            <td v-if="currentDossier.classe !== 'Aérien' && currentDossier.classe !== 'Groupage'">{{marchandise.cont_type}}</td>
                                            <td>{{marchandise.description}}</td>
                                            <td>{{marchandise.poids}} Kg</td>
                                            <td class="text-left" v-if="currentDossier.classe === 'Groupage'">{{marchandise.volume}}</td>

                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr class="text-center">
                                            <td v-if="currentDossier.classe === 'Aérien'" colspan="4">Aucune donnée disponible</td>
                                            <td v-else-if="currentDossier.classe === 'Groupage'" colspan="5">Aucune donnée disponible</td>
                                            <td v-else colspan="6">Aucune donnée disponible</td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider  style="width:98%; margin: 0 auto;"></v-divider>
                <v-card-title style="font-size:36px;"><b><span>Préstations</span></b></v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col md="12">
                                <v-simple-table class="text-left" dense>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                        <th class="text-left">Code</th>
                                        <th class="text-left">Description Préstation</th>
                                        <th class="text-left">Taux TVA %</th>
                                        <th class="text-left">Montant TVA</th>
                                        <th class="text-left">Devise</th>
                                        <th class="text-left">Cours</th>
                                        <th class="text-left">Montant Devise</th>
                                        <th class="text-left">Montant (TND)</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="prestations.length > 0">
                                        <tr v-for="(prestation, key) in prestations" v-bind:key="key">
                                            <td>{{prestation.code_prestation}}</td>
                                            <td>{{prestation.description}}</td>
                                            <td>{{prestation.tva}}</td>
                                            <td>{{prestation.montantTva.toFixed(3)}}</td>
                                            <td>{{prestation.devise}}</td>
                                            <td>{{prestation.cour.toFixed(3)}}</td>
                                            <td>{{prestation.montantDevise.toFixed(2)}}</td>
                                            <td>{{prestation.montant.toFixed(3)}}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr class="text-center">
                                            <td colspan="8">Aucune données disponible.</td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-col>
            <v-col cols="12" md="3" style="position:absolute; text-align:left; right:0; background:white;">
                <v-card-title style="font-size: 36px;"><span><b>Total Facture</b></span></v-card-title>
                <span class="total-line">Total Non Taxable : <b style="float:right;">{{totalnt.toFixed(3)}} TND</b></span><br/>
                <span class="total-line">Total Taxable : <b style="float:right;">{{totalt.toFixed(3)}} TND</b></span><br/>
                <span class="total-line">Total TVA : <b style="float:right;">{{totaltva.toFixed(3)}} TND</b></span><br/>
                <span class="total-line">Timbre Fiscal :<b style="float:right;"> {{ factureContent.timbre.toFixed(3) }} TND</b></span><br/>
                <span class="total-line">Total TTC : <b style="float:right;">{{total.toFixed(3)}} TND</b></span><br/>
            </v-col>
        </v-row>
        <v-card-title style="font-size: 36px; margin-top:115px;">
            <span><b>Réglement</b></span>
            <v-spacer></v-spacer>
            <v-switch
            v-model="reglement"
            ></v-switch>
        </v-card-title>
        <v-card-text v-if="reglement">
            <v-snackbar
                style="z-index: 999999;"
                v-model="snackbar"
                :color="snackColor"
                right
                top
                >
                {{ snackText }}

                <template v-slot:action="{ attrs }">
                    <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                    >
                    Fermer
                    </v-btn>
                </template>
            </v-snackbar>
            <v-container fluid>
                <v-row>
                    <v-col md="2">
                        <v-text-field
                            label="Mode Réglement"
                            v-model="reglementTmp.mode"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="Banque"
                            v-model="reglementTmp.banque"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="N° Pièce"
                            v-model="reglementTmp.num_piece"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-text-field
                            label="Client"
                            v-model="reglementTmp.client"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="Montant"
                            v-model="reglementTmp.montant"
                            type="Number"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="1">
                        <v-btn color="primary" @click="setReglement" text><v-icon>mdi-arrow-down</v-icon> Ajouter</v-btn>
                    </v-col>
                    <v-col md="12">
                        <v-simple-table class="text-left" dense>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">Mode Réglement</th>
                                <th class="text-left">Banque</th>
                                <th class="text-left">N° Pièce</th>
                                <th class="text-left">Client</th>
                                <th class="text-left">Montant</th>
                                <th class="text-left">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(reglement, key) in currentFacture.reglement" v-bind:key="key">
                                    <td>{{reglement.mode}}</td>
                                    <td>{{reglement.banque}}</td>
                                    <td>{{reglement.num_piece}}</td>
                                    <td>{{reglement.client}}</td>
                                    <td>{{reglement.montant}} TND</td>
                                    <td>
                                        <v-icon
                                            small
                                            @click="deleteReglement(reglement)"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeFacture">Fermer</v-btn>
        <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="closeFacture">Imprimer</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

export default {
    name:'single-standard-facture',
    props: ['factureContent'],
    data: () => ({
        reglement: true,
        currentFacture: {
            client: {},
            reglement: []
        },
        avisContentData: {
            dossier: {},
            client: {},
            correspondant: {},
            agent: {}
        },
        prestations: [],
        totalnt: 0,
        totalt: 0,
        totaltva: 0,
        total: 0,
        numFactureToEdit: '',
        factureNumberError: false,
        factureNumberErrorMessages: [],
        EditNumberDialog: false,
        snackbar: false,
        snackText: '',
        snackColor: '',
        reglementTmp: {
            montant: 0,
            mode: '',
            client: '',
            num_piece: '',
            banque: ''
        },
        currentDossier: {},
        clientList: [],
        marchandises: [],
        contList: []
    }),
    watch: {
        prestations: {
            deep: true,
            handler: 'calculate'
        },
        currentFacture: {
            deep: true,
            handler: function() {
                this.numFactureToEdit = this.currentFacture.num_facture
            }
        }
    },
    async mounted(){
        this.axios
            .get('/client/listing')
            .then(response => (this.clientList = response.data))

        await this.axios
            .get('/conteneur/listing')
            .then( (res) => (this.contList = res.data))

        await this.axios
            .get('/facture/single/'+this.factureContent.id)
            .then(response => {
                
                 if(Number(response.data.avis_id) === 0 && response.data.dossier_id > 0){
                    response.data.client = this.clientList.filter(obj => {
                        return obj.id === response.data.client_id
                    })[0]
                    
                    response.data.data.forEach((item, key) => {
                        if(item.name === 'correspondant_id'){
                            this.axios
                            .get('/correspondant/listing')
                            .then(res => 
                            {
                                response.data.correspondant = res.data.filter(obj => {
                                    return obj.id === Number(item.value)
                                })[0]
                            })
                            
                        }else if(item.name === 'agent_id'){
                            this.axios
                            .get('/agent/listing')
                            .then(res => 
                            {
                                response.data.agent = res.data.filter(obj => {
                                    return obj.id === Number(item.value)
                                })[0]
                            })
                        }else{
                            response.data[item.name] = item.value
                        }
                    })
                    response.data.marchandise.forEach((item, index) => {
                        if(Number(item.cont_type_id) > 0){
                            this.axios
                                .get('/conteneur/listing')
                                .then(res => {
                                    item.cont_type = res.data.filter(obj => {
                                        return obj.id === item.cont_type_id
                                    })[0].titre
                                })
                            response.data.marchandise[index] = item
                        }
                    })

                    var self = this
                    setTimeout(function(){
                        self.currentFacture = response.data
                        self.marchandises = response.data.marchandise
                    },300)
                    this.prestations = response.data.prestations
                    this.calculate()
                }else if(response.data.avis_id === 0 && response.data.dossier_id === 0){
                    response.data.client = this.clientList.filter(obj => {
                        return obj.id === response.data.client_id
                    })[0]
                    response.data.data.forEach((item, key) => {
                        if(item.name === 'agent_id'){
                            response.data.data[key].name = 'Agent Commercial'
                            this.axios
                            .get('/agent/listing')
                            .then(res => 
                            {
                                
                                response.data.data[key].value = res.data.filter(obj => {
                                    return obj.id === Number(item.value)
                                })[0].nom
                            })
                        }else{
                            response.data[item.name] = item.value
                        }
                    })
                    response.data.marchandise.forEach((item, index) => {
                        if(Number(item.cont_type_id) > 0){
                            item.cont_type = this.contList.filter(obj => {
                                return obj.id === item.cont_type_id
                            })[0].titre
                            response.data.marchandise[index] = item
                        }
                    })

                    /*var self = this
                    setTimeout(function(){
                        self.currentFacture = response.data
                        self.marchandises = response.data.marchandise
                    },300)*/
                    this.currentFacture = response.data
                    this.marchandises = response.data.marchandise
                    this.prestations = response.data.prestations
                    //console.log(response.data)
                    this.calculate()
                }else{
                    var self = this
                    setTimeout(function(){
                        self.currentFacture = response.data
                    },300)
                }
                
                
            })
            .catch(error => console.log(error))
        
        if(this.factureContent.dossier_id > 0){
            this.axios
                .get('/dossier/single/'+this.factureContent.dossier_id)
                .then(response => {
                    //this.currentDossier = response.data[0]
                    var self = this
                    setTimeout(function(){
                        self.currentDossier = response.data[0]
                    },300)
                })
        }
        if(Number(this.factureContent.avis_id) > 0){
            this.axios
                .get("/avis/single/"+this.factureContent.avis_id)
                .then(result => {
                    this.avisContentData = result.data
                    this.prestations = result.data.prestations
                    this.marchandises = result.data.marchandises
                    this.calculate()
                })
                .catch(error => console.log(error))
                var self = this
                setTimeout(function(){
                    console.log(self.avisContentData)
                },1000)
        }
        
    },
    methods: {
        closeFacture(){
            this.$emit('hideDialog', true)
        },
        calculate(){
            this.totalnt = 0
            this.totalt = 0
            this.totaltva = 0
            this.total = 0
            this.prestations.forEach((item , index) => {
                item.cour = Number(item.cour)
                item.montant = Number(item.montant)
                item.montantDevise = Number(item.montantDevise)
                item.tva = Number(item.tva)
                item.montantTva = Number(item.montant.toFixed(3)) * item.tva / 100
                if(item.cour > 0){
                    this.prestations[index].montant = item.cour * item.montantDevise
                } 
                if(item.tva === 0){
                    this.totalnt = item.montant + this.totalnt
                }else{
                    this.totaltva = item.montant * item.tva / 100  + this.totaltva
                    this.totalt = item.montant + this.totalt
                }
            })
            this.total =  Number(this.total.toFixed(3)) + Number(this.totalnt.toFixed(3)) + Number(this.totalt.toFixed(3)) + Number(this.totaltva.toFixed(3)) + Number(this.factureContent.timbre.toFixed(3))
        },
        setReglement(){
            if(this.reglementTmp.mode === '' || this.reglementTmp.client === '' || Number(this.reglementTmp.montant) === 0){
                this.snackText = "Veuillez Remplir tous les cases obligatoires dans le règlement."
                this.snackColor = "error"
                this.snackbar = true
            }else{
                this.reglementTmp.montant = Number(this.reglementTmp.montant).toFixed(3)
                let montant = this.reglementTmp.montant
                if(this.currentFacture.reglement.length > 0){
                    this.currentFacture.reglement.forEach((item,index) => {
                        montant = Number(Number(montant) + Number(Number(item.montant).toFixed(3)))
                    })
                }
                
                if( montant > Number(this.total.toFixed(3))){
                    this.snackText = "Le montant total des règlements ne doit pas dépasser le montant total de la facture."
                    this.snackColor = "error"
                    this.snackbar = true
                }else{
                    this.reglementTmp.facture_id = this.factureContent.id
                    this.axios
                        .post('/facture/reglement/set', this.reglementTmp, {})
                        .then(response => {
                            this.reglementTmp.id = response.data
                            this.currentFacture.reglement.push(this.reglementTmp)
                            this.reglementTmp = {
                                montant: 0,
                                mode: '',
                                client: '',
                                num_piece: '',
                                banque: ''
                            }
                            this.snackColor = "success"
                            this.snackText = "Le règlement a été ajouté avec succès."
                            this.snackbar = true
                            this.$emit('reloadData')
                        })
                }
            }
        },
        deleteReglement(item){
            const index = this.currentFacture.reglement.indexOf(item)
            if(confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?')){
                this.axios
                    .delete('/facture/reglement/delete/'+item.id)
                    .then(response => {
                        this.currentFacture.reglement.splice(index, 1)
                        this.snackColor = "success"
                        this.snackText = "Le règlement a été supprimé avec succès."
                        this.snackbar = true
                        this.$emit('reloadData')
                    })
            }
        },
        close() {
            this.numFactureToEdit = this.factureContent.num_facture
            this.factureNumberError = false
            this.factureNumberErrorMessages = ''
            this.EditNumberDialog = false
        },
        updateNumber() {
            var self = this
            this.factureNumberError = false
            this.factureNumberErrorMessages = ''
            if(this.factureContent.num_facture == this.numFactureToEdit) {
                this.snackColor = "success"
                this.snackText = "Même numéro de facture sauvgardé."
                this.snackbar = true
                this.EditNumberDialog = false
            } else {
                setTimeout(function(){
                    self.axios.put('/facture/update_number', {...self.factureContent, num_facture: self.numFactureToEdit}, {
                    }).then((res) => {
                        if(res.data === 'error'){
                        self.snackColor = "error"
                        self.snackText = "Essayez de remplir tous les champs obligatoires."
                        self.snackbar = true
                        }else{
                            if(res.data.exists) {
                                self.factureNumberError = true
                                self.factureNumberErrorMessages = 'Nouveau numéro existant, ressayez un numéro auxiliaire en cas de permutation'
                                self.snackColor = "error"
                                self.snackText = "Nouveau numéro existant!"
                                self.snackbar = true
                            } else {
                                self.snackColor = "success"
                                self.snackText = "La facture a été modifié avec succès."
                                self.snackbar = true
                                self.$emit('reloadData')
                                self.factureContent.num_facture = self.numFactureToEdit
                                self.EditNumberDialog = false
                            }
                        //self.closeFacture()
                        }
                    }).catch(e => {
                        self.snackColor = "error"
                        self.snackbar = true
                        self.snackText = "Un erreur est survenu, essayez plus tard."
                        console.log(e)
                    })

                },500)
            }
        }
    }
}
</script>
<style scoped>
.total-line{
    line-height: 45px;
    font-size: 18px;
    padding-left: 15px;
}
.total-prices span{
    font-size: 16px;
    display: block;
    line-height: 9px;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/facture/standard/single.component.vue